export default "__VITE_ASSET__ApkwQIfd__"